var _classCallCheck = require("/builds/frontend/microfrontends/foxtrot/app-frontend-lps/node_modules/babel-preset-getresponse/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/builds/frontend/microfrontends/foxtrot/app-frontend-lps/node_modules/babel-preset-getresponse/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("absolute-font-size-fix", [], t) : "object" == typeof exports ? exports["absolute-font-size-fix"] = t() : e["absolute-font-size-fix"] = t();
}(self, function () {
  return function () {
    "use strict";

    var e = {
        246: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.allFontSizeSelector = void 0, t.allFontSizeSelector = "[style*=font]:not(html)";
        },
        909: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.defaultPxToRem = void 0, t.defaultPxToRem = 16;
        },
        607: function _(e, t, o) {
          var i = this && this.__createBinding || (Object.create ? function (e, t, o, i) {
              void 0 === i && (i = o), Object.defineProperty(e, i, {
                enumerable: !0,
                get: function get() {
                  return t[o];
                }
              });
            } : function (e, t, o, i) {
              void 0 === i && (i = o), e[i] = t[o];
            }),
            n = this && this.__exportStar || function (e, t) {
              for (var o in e) {
                "default" === o || Object.prototype.hasOwnProperty.call(t, o) || i(t, e, o);
              }
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.fixFontSize = void 0;
          var r = o(593),
            s = o(503),
            l = o(20);
          n(o(246), t), n(o(20), t), n(o(503), t), n(o(645), t), n(o(396), t), n(o(593), t), n(o(540), t), n(o(316), t), t.fixFontSize = function () {
            var _s$store$get = s.store.get(),
              e = _s$store$get.isInitial;
            if (e) return l.debug.log("Fix already implemented");
            r.tryFixFontSize();
          };
        },
        611: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.DebugLogger = void 0;
          var i = o(791),
            n = o(671);
          t.DebugLogger = /*#__PURE__*/function () {
            function _class() {
              _classCallCheck(this, _class);
              this.instance = new i.MemoryLogger(), this.shouldSwitchToWindowDebug = !1;
            }
            _createClass(_class, [{
              key: "log",
              value: function log() {
                var _this$instance;
                this.shouldSwitchToWindowDebug && this.instance instanceof i.MemoryLogger && (null === document || void 0 === document ? void 0 : document.body) && this.switchLogger(), (_this$instance = this.instance).log.apply(_this$instance, arguments);
              }
            }, {
              key: "get",
              value: function get() {
                return this.instance.get();
              }
            }, {
              key: "clear",
              value: function clear() {
                this.instance.clear();
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.instance.dispose();
              }
            }, {
              key: "switchLogger",
              value: function switchLogger() {
                var _this = this;
                if (this.instance instanceof i.MemoryLogger) {
                  var _e = this.instance.get();
                  this.instance = new n.WindowDebugLogger(), _e.forEach(function (e) {
                    return _this.instance.log(e);
                  });
                }
              }
            }]);
            return _class;
          }();
        },
        791: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.MemoryLogger = void 0, t.MemoryLogger = /*#__PURE__*/function () {
            function _class2() {
              _classCallCheck(this, _class2);
              this.logs = [];
            }
            _createClass(_class2, [{
              key: "get",
              value: function get() {
                return this.logs;
              }
            }, {
              key: "log",
              value: function log() {
                for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
                  e[_key] = arguments[_key];
                }
                this.logs.push(e.join(" "));
              }
            }, {
              key: "clear",
              value: function clear() {
                this.logs = [];
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.clear();
              }
            }]);
            return _class2;
          }();
        },
        671: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.WindowDebugLogger = void 0, t.WindowDebugLogger = /*#__PURE__*/function () {
            function _class3() {
              _classCallCheck(this, _class3);
              this.container = this.create();
            }
            _createClass(_class3, [{
              key: "get",
              value: function get() {
                return this.container.innerText.split("\n");
              }
            }, {
              key: "log",
              value: function log() {
                for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  e[_key2] = arguments[_key2];
                }
                this.container.appendChild(document.createTextNode([].concat(e, ["\n"]).join(" ")));
              }
            }, {
              key: "clear",
              value: function clear() {
                for (var e; null === (e = this.container) || void 0 === e ? void 0 : e.lastChild;) {
                  this.container.removeChild(this.container.lastChild);
                }
              }
            }, {
              key: "dispose",
              value: function dispose() {
                this.container && document.body.removeChild(this.container);
              }
            }, {
              key: "create",
              value: function create() {
                var e = document.createElement("pre");
                return e.style.position = "fixed", e.style.bottom = "0", e.style.width = "100%", e.style.maxHeight = "30vh", e.style.background = "pink", e.style.zIndex = "10000", e.style.overflow = "auto", document.body.appendChild(e), e;
              }
            }]);
            return _class3;
          }();
        },
        20: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.debug = void 0;
          var i = o(611);
          t.debug = new i.DebugLogger();
        },
        632: function _(e, t) {
          var o;
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CSSUnit = void 0, (o = t.CSSUnit || (t.CSSUnit = {})).px = "px", o.rem = "rem";
        },
        572: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CSSValue = void 0;
          var o = /*#__PURE__*/function () {
            function o(e, t) {
              _classCallCheck(this, o);
              this.value = e, this.unit = t;
            }
            _createClass(o, [{
              key: "toString",
              value: function toString() {
                return "".concat(this.value).concat(this.unit);
              }
            }], [{
              key: "px",
              value: function px(e) {
                return new o(e, "px");
              }
            }, {
              key: "rem",
              value: function rem(e) {
                return new o(e, "rem");
              }
            }, {
              key: "tryParse",
              value: function tryParse(e) {
                var t = e ? /^(\d+\.?\d*)(\S+)/.exec(e) : void 0;
                if (t) return new o(parseFloat(t[1]), t[2]);
              }
            }]);
            return o;
          }();
          t.CSSValue = o;
        },
        154: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Store = void 0, t.Store = /*#__PURE__*/function () {
            function _class4(e) {
              _classCallCheck(this, _class4);
              this.state = e;
            }
            _createClass(_class4, [{
              key: "get",
              value: function get() {
                return this.state;
              }
            }, {
              key: "set",
              value: function set(e) {
                this.state = Object.assign(Object.assign({}, this.state), e);
              }
            }]);
            return _class4;
          }();
        },
        503: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.store = void 0;
          var i = o(154);
          t.store = new i.Store({
            isInitial: !1,
            shouldMigrate: !1,
            baseFontSize: void 0,
            fontSize: void 0
          });
        },
        951: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.convertPxToRem = void 0;
          var i = o(572),
            n = o(909);
          t.convertPxToRem = function (e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : n.defaultPxToRem;
            return i.CSSValue.rem(e / t);
          };
        },
        303: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.findFontSize = void 0;
          var i = o(827);
          t.findFontSize = function (e) {
            var t = document.createElement("div");
            t.style.display = "none", document.body.appendChild(t);
            var o = i.tryFindOptimalFontSize(t, e);
            return document.body.removeChild(t), o;
          };
        },
        645: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.migrateFontSizeInInlineStyles = void 0;
          var i = o(506);
          t.migrateFontSizeInInlineStyles = function (e, t) {
            var _iterator = _createForOfIteratorHelper(e),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _o = _step.value;
                (null == _o ? void 0 : _o.style) && i.migrateFontSizeStyle(_o.style, t);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          };
        },
        396: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.migrateFontSizeInStyles = void 0;
          var i = o(20),
            n = o(506);
          t.migrateFontSizeInStyles = function (e, t) {
            var _iterator2 = _createForOfIteratorHelper(e),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _o2 = _step2.value;
                try {
                  var _iterator3 = _createForOfIteratorHelper(_o2.cssRules),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var _e2 = _step3.value;
                      var _o3 = _e2;
                      (null == _o3 ? void 0 : _o3.style) && n.migrateFontSizeStyle(_o3.style, t);
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                } catch (e) {
                  i.debug.log("Access denied", e.message, _o2.href);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          };
        },
        999: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.migrateFontSizePxToRem = void 0;
          var i = o(20),
            n = o(396),
            r = o(645),
            s = o(246);
          t.migrateFontSizePxToRem = function (e) {
            i.debug.log("Migrate font size from px to rem in styles", document.styleSheets.length), n.migrateFontSizeInStyles(document.styleSheets, e);
            var t = document.querySelectorAll(s.allFontSizeSelector);
            i.debug.log("Migrate font size from px to rem in inline style elements", t.length), r.migrateFontSizeInInlineStyles(t, e);
          };
        },
        506: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.migrateFontSizeStyle = void 0;
          var i = o(632),
            n = o(572),
            r = o(951);
          t.migrateFontSizeStyle = function (e, t) {
            var o = n.CSSValue.tryParse(e.getPropertyValue("font-size"));
            (null == o ? void 0 : o.unit) === i.CSSUnit.px && e.setProperty("font-size", r.convertPxToRem(o.value, t).toString());
          };
        },
        827: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.tryFindOptimalFontSize = void 0;
          var i = o(572),
            n = o(20);
          t.tryFindOptimalFontSize = function (e, t) {
            var o;
            var r = 0;
            for (var s = 0; s < 15; s++) {
              var l = (null !== (o = i.CSSValue.tryParse(getComputedStyle(e).fontSize)) && void 0 !== o ? o : i.CSSValue.px(0)).value - t;
              if (Math.abs(l) < .001) return n.debug.log("Optimal value found in iteration", s), t - r;
              r += .8 * l, e.style.fontSize = i.CSSValue.px(t - r).toString();
            }
            return n.debug.log("Algorithm cannot find optimal value"), t;
          };
        },
        593: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.tryFixFontSize = void 0;
          var i = o(632),
            n = o(572),
            r = o(20),
            s = o(303),
            l = o(999),
            a = o(503),
            d = o(909);
          t.tryFixFontSize = function () {
            var e;
            var t = Date.now();
            try {
              r.debug.log("Initial fix for font size");
              var _o4 = document.documentElement,
                u = null !== (e = n.CSSValue.tryParse(_o4.style.getPropertyValue("font-size"))) && void 0 !== e ? e : n.CSSValue.px(d.defaultPxToRem);
              if (a.store.set({
                isInitial: !0,
                baseFontSize: u
              }), r.debug.log("Html base font size", u), u.unit !== i.CSSUnit.px) return r.debug.log("To fix the problem, base font size unit must be px!");
              var c = s.findFontSize(u.value);
              r.debug.log("Correct font size", c);
              var g = c !== u.value;
              a.store.set({
                fontSize: c,
                shouldMigrate: g
              }), r.debug.log("Should migrate", g), g && (l.migrateFontSizePxToRem(u.value), _o4.style.fontSize = n.CSSValue.px(c).toString(), r.debug.log("Set new font size for html", _o4.style.fontSize));
            } catch (e) {
              r.debug.log("Error in fix", null == e ? void 0 : e.message);
            } finally {
              var _e3 = Date.now() - t;
              r.debug.log("Finish fix for font size", "(time: ".concat(_e3, "ms)"));
            }
          };
        },
        540: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.tryMigrateFontSize = void 0;
          var i = o(20),
            n = o(503),
            r = o(999);
          t.tryMigrateFontSize = function () {
            var _n$store$get = n.store.get(),
              e = _n$store$get.shouldMigrate,
              t = _n$store$get.baseFontSize;
            if (e && t) try {
              r.migrateFontSizePxToRem(t.value);
            } catch (e) {
              i.debug.log("Cannot migrate font size", null == e ? void 0 : e.message);
            }
          };
        },
        316: function _(e, t, o) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.tryMigrateFontSizeInline = void 0;
          var i = o(503),
            n = o(20),
            r = o(645);
          t.tryMigrateFontSizeInline = function (e) {
            var _i$store$get = i.store.get(),
              t = _i$store$get.shouldMigrate,
              o = _i$store$get.baseFontSize;
            if (t && o) try {
              r.migrateFontSizeInInlineStyles(e, o.value);
            } catch (e) {
              n.debug.log("Cannot migrate font size", null == e ? void 0 : e.message);
            }
          };
        }
      },
      t = {};
    return function o(i) {
      var n = t[i];
      if (void 0 !== n) return n.exports;
      var r = t[i] = {
        exports: {}
      };
      return e[i].call(r.exports, r, r.exports, o), r.exports;
    }(607);
  }();
});